<div class="spacing-top">
	<div data-testid="SUBSYS7_TOOLSMENU_BACKDEF_BTN" class="wrapper-back" (click)="openBackToDefModal()"
		(keypress)="openBackToDefModal()">
		<span class="material-icons md-18 back">arrow_back</span>
		<span class="action">{{ labels().TOOLS_MENU_COMPONENT_BACK_DEFORMITY }}</span>
	</div>
</div>

<div class="main-step">
	<div class="spacing-top justify-content-end bg-transparent">
		<span data-testid="SUBSYS7_TOOLSMENU_UNDO_BTN" class="material-icons material-icons-outlined px-2 active"
			[class.disabled]="!isUndoEnabled" (click)="undo()" (keypress)="undo()">undo</span>
		<span data-testid="SUBSYS7_TOOLSMENU_REDO_BTN" class="material-icons material-icons-outlined px-2 active"
			[class.disabled]="!isRedoEnabled" (click)="redo()" (keypress)="redo()">redo</span>
	</div>

	<image-elaboration [view]="activeView" />

	<!-- MENU REVERSE PLANNING METHOD -->
	<div class="box-menu-settings active">

		<div class="row-box" style="padding-left: 1rem; padding-right: 0.5rem;">
			<h4>{{ labels().TOOLS_MENU_COMPONENT_RPM }}</h4>
			@if (isStrokeLocked) { <div class="check-success ms-auto"></div> }
		</div>

		<div class="divider-box"></div>

		<div data-testid="SUBSYS7_TOOLSMENU_INSERTION_APPROACH_BTN" class="row-box"
			[class]="{'clickable': !isEocCut, 'disabled': !!isEocCut }" customTooltip
			[activeTooltip]="step === stepEnum.InsApproach" [valueTooltip]="labels().TOOLS_MENU_COMPONENT_TOOLTIP_NEXT_STEP"
			(click)="openOsteotomyWorkflow()" (keypress)="openOsteotomyWorkflow()">
			<div class="fake-material-icon osteotomy"></div>
			<span>{{ labels().TOOLS_MENU_COMPONENT_INSERTION_APPROACH }}</span>
		</div>
		<div data-testid="SUBSYS7_TOOLSMENU_CROP_SEGMENT_BTN" class="row-box"
			[class]="{'clickable': !!selectedApex, 'disabled': !selectedApex }" customTooltip
			[activeTooltip]="step === stepEnum.Cut" [valueTooltip]="labels().TOOLS_MENU_COMPONENT_TOOLTIP_OPTIONAL_STEP"
			[optionalStyle]="true" (click)="setResize()" (keypress)="setResize()">
			<i class="material-icons">transform</i>
			<span>{{ labels().TOOLS_MENU_COMPONENT_CROP_SEGMENT }}</span>
		</div>
		@if (cutForm) {
		<form [formGroup]="cutForm">
			<div class="row-box flex-wrap pe-0" [class]="{'disabled': !selectedApex }" customTooltip
				[activeTooltip]="step === stepEnum.Cut" [valueTooltip]="labels().TOOLS_MENU_COMPONENT_TOOLTIP_NEXT_STEP">
				<i class=" material-icons">crop_rotate</i>
				<span>{{ labels().TOOLS_MENU_COMPONENT_CUT }}</span>
				<div class="form-group switch-custom-container align-items-center pb-0 ms-4 mb-0" style="width: fit-content;">
					<label data-testid="SUBSYS7_TOOLSMENU_CUT_BTN" class="switch" aria-label="enable cut mode" (click)="setCut()"
						(keypress)="setCut()">
						<input type="checkbox" formControlName="cut" />
						<span></span>
					</label>
					<p class="mb-0">{{ labels().TOOLS_MENU_COMPONENT_ON_OFF }}</p>
					<i data-testid="SUBSYS7_TOOLSMENU_RESET_CUT_BTN" class="material-icons img-action p-2 ms-3"
						[class]="{'clickable': isEocCut, 'not-allowed': !isEocCut, 'disabled': !isEocCut && selectedApex }"
						(click)="resetCut()" (keypress)="resetCut()">
						sync
					</i>
				</div>
			</div>
		</form>
		}
		<div data-testid="SUBSYS7_TOOLSMENU_FITBONE_SELECTION_BTN" class="row-box"
			[class]="{'clickable': !!isEocCut, 'disabled': !isEocCut }" customTooltip
			[activeTooltip]="step === stepEnum.FitBone" [valueTooltip]="labels().TOOLS_MENU_COMPONENT_TOOLTIP_NEXT_STEP"
			(click)="openFitboneWorkflow()" (keypress)="openFitboneWorkflow()">
			<div class="fake-material-icon template"></div>
			<span>{{ labels().TOOLS_MENU_COMPONENT_FITBONE_SELECTION }}</span>
		</div>
		@if (fitboneForm) {
		<form [formGroup]="fitboneForm">
			<div class="row-box flex-wrap pe-0" [class]="{'disabled': !isFitboneInserted }" customTooltip
				[activeTooltip]="step === stepEnum.Stroke" [valueTooltip]="labels().TOOLS_MENU_COMPONENT_TOOLTIP_NEXT_STEP">
				<i class=" material-icons">lock</i>
				<span>{{ labels().TOOLS_MENU_COMPONENT_STROKE }}</span>
				<div class="form-group switch-custom-container align-items-center pb-0 ms-4 mb-0" style="width: fit-content;">
					<label data-testid="SUBSYS7_TOOLSMENU_LOCK_BTN" class="switch" aria-label="enable lock mode"
						(click)="setLock()" (keypress)="setLock()">
						<input type="checkbox" formControlName="lock" />
						<span></span>
					</label>
					<p class="mb-0">
						{{ isStrokeLocked ? labels().TOOLS_MENU_COMPONENT_LOCKED : labels().TOOLS_MENU_COMPONENT_UNLOCKED }}</p>
				</div>
			</div>
		</form>
		}
		<div class="row-box flex-wrap pe-0" [class]="{ 'disabled': !isStrokeLocked }" customTooltip
			[activeTooltip]="step === stepEnum.View" [valueTooltip]="labels().TOOLS_MENU_COMPONENT_TOOLTIP_OPTIONAL_STEP"
			[optionalStyle]="true">
			<i class="material-icons">push_pin</i>
			<span>{{ labels().TOOLS_MENU_COMPONENT_BLOCKING_SCREW }}</span>
			<i data-testid="SUBSYS7_TOOLSMENU_BLOCKINGSCREW_ADD_BTN" class="material-icons img-action p-2 ms-4"
				style="max-width: fit-content;" [title]="labels().TOOLS_MENU_COMPONENT_BLOCKING_SCREW_ADD"
				(click)="addBlockingScrew()" (keypress)="addBlockingScrew()"
				[class]="{'clickable': !isAddDisabled, 'not-allowed': isAddDisabled, 'disabled': isAddDisabled && isStrokeLocked }">
				add_circle
			</i>
			<i data-testid="SUBSYS7_TOOLSMENU_BLOCKINGSCREW_DELETE_BTN" class="material-icons img-action p-2 ms-1"
				style="max-width: fit-content;" [title]="labels().TOOLS_MENU_COMPONENT_BLOCKING_SCREW_DELETE"
				(click)="deleteBlockingScrew()" (keypress)="deleteBlockingScrew()"
				[class]="{'clickable': !isDeleteDisabled, 'not-allowed': isDeleteDisabled, 'disabled': isDeleteDisabled && isStrokeLocked }">
				delete_outline
			</i>
		</div>

	</div>

	<!-- FOOTER MENU -->
	<div class="box-menu-settings active">

		<div class="row-box" style="padding-left: 1rem;">
			<h4>{{ labels().TOOLS_MENU_COMPONENT_VISUALIZE }}</h4>
		</div>

		<div class="divider-box"></div>

		<div class="row-box" data-testid="SUBSYS7_TOOLSMENU_PRINTOR_BTN" (click)="printOR()" (keypress)="printOR()"
			[class]="{'clickable': isStrokeLocked, 'disabled': !isStrokeLocked }" customTooltip
			[activeTooltip]="step === stepEnum.View" [valueTooltip]="labels().TOOLS_MENU_COMPONENT_TOOLTIP_VIEW_PLAN"
			[optionalStyle]="true">
			<i class="material-icons">local_printshop</i>
			<span>{{ labels().TOOLS_MENU_COMPONENT_OR_PLAN }}</span>
		</div>

		<div class="row-box" data-testid="SUBSYS7_TOOLSMENU_VIEWER_BTN" (click)="showViewer()" (keypress)="showViewer()"
			[class]="{'clickable': isStrokeLocked, 'disabled': !isStrokeLocked }" customTooltip
			[activeTooltip]="step === stepEnum.View" [valueTooltip]="labels().TOOLS_MENU_COMPONENT_TOOLTIP_VIEW_PLAN"
			[optionalStyle]="true">
			<i class="material-icons">search</i>
			<span>{{ labels().TOOLS_MENU_COMPONENT_VIEWER }}</span>
		</div>

	</div>

</div>